/**
 * Flowchart and Process Diagram nodes with animated pulse borders.
 */
import { SVGObject, SVGObjectConfig } from './SVGObject';
import { Renderer } from '../core/Renderer';

export type FlowNodeType = 'process' | 'decision' | 'terminal' | 'io';

export interface FlowNodeProps {
  nodeType?: FlowNodeType;
  label: string;
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  textColor?: string;
  active?: boolean;
}

export class FlowNode extends SVGObject {
  public props: FlowNodeProps;

  constructor(config: SVGObjectConfig & { props?: FlowNodeProps }) {
    super({ ...config, type: 'flowchart' });
    this.props = {
      nodeType: 'process',
      label: 'Step',
      width: 160,
      height: 60,
      fill: '#1e293b',
      stroke: '#38bdf8',
      textColor: '#f8fafc',
      active: false,
      ...config.props
    };
  }

  public render(): void {
    this.container.innerHTML = '';
    const w = this.props.width || 160;
    const h = this.props.height || 60;
    const type = this.props.nodeType || 'process';

    if (type === 'terminal') {
      const r = Renderer.createElement('rect');
      Renderer.setAttributes(r, {
        x: -w / 2,
        y: -h / 2,
        width: w,
        height: h,
        rx: h / 2,
        ry: h / 2,
        fill: this.props.fill || '#1e293b',
        stroke: this.props.stroke || '#38bdf8',
        'stroke-width': this.props.active ? 3 : 1.5,
        filter: this.props.active ? 'url(#asae-glow)' : null
      });
      this.container.appendChild(r);
    } else if (type === 'decision') {
      const p = Renderer.createElement('polygon');
      Renderer.setAttributes(p, {
        points: `0,${-h / 2} ${w / 2},0 0,${h / 2} ${-w / 2},0`,
        fill: this.props.fill || '#1e293b',
        stroke: this.props.stroke || '#fbbf24',
        'stroke-width': this.props.active ? 3 : 1.5,
        filter: this.props.active ? 'url(#asae-glow)' : null
      });
      this.container.appendChild(p);
    } else {
      const r = Renderer.createElement('rect');
      Renderer.setAttributes(r, {
        x: -w / 2,
        y: -h / 2,
        width: w,
        height: h,
        rx: 8,
        ry: 8,
        fill: this.props.fill || '#1e293b',
        stroke: this.props.stroke || '#38bdf8',
        'stroke-width': this.props.active ? 3 : 1.5,
        filter: this.props.active ? 'url(#asae-glow)' : null
      });
      this.container.appendChild(r);
    }

    // Label Text
    const text = Renderer.createElement('text');
    Renderer.setAttributes(text, {
      x: 0,
      y: 0,
      'font-size': 14,
      'font-family': 'Inter, sans-serif',
      'font-weight': '600',
      fill: this.props.textColor || '#f8fafc',
      'text-anchor': 'middle',
      'dominant-baseline': 'central'
    });
    text.textContent = this.props.label || '';
    this.container.appendChild(text);
  }

  public setActive(active: boolean): void {
    this.props.active = active;
    this.render();
  }
}
